import { publicApi } from "../services/publicApi";
import { privateApi } from "../services/privateApi";
import { proofupApi } from "../services/proofupApi";

export const reducers = {
  [publicApi.reducerPath]: publicApi.reducer,
  [privateApi.reducerPath]: privateApi.reducer,
  [proofupApi.reducerPath]: proofupApi.reducer,
};
